import { fromPairs, groupBy, keyBy, union } from 'lodash';
import { MemberType, UserStatus } from 'api/models/core-types';
import { Empty, Loaded } from 'stores/core';
const MEMBER_TYPES = [
    MemberType.Native,
    MemberType.External
];
const EMPTY = {
    byId: {},
    ids: Empty(),
    active: [],
    byCompanyId: {},
    byMemberType: fromPairs(MEMBER_TYPES.map((x)=>[
            x,
            []
        ]))
};
const putAll = (users)=>()=>{
        const ids = users.map(({ userId })=>userId);
        const lookup = keyBy(users, 'userId');
        return {
            byId: fromPairs(ids.map((id)=>[
                    id,
                    Loaded(lookup[id])
                ])),
            ids: Loaded(ids),
            active: ids.filter((id)=>lookup[id].userStatus !== UserStatus.Inactive),
            byCompanyId: groupBy(ids, (id)=>lookup[id].company.companyId),
            byMemberType: groupBy(ids, (id)=>lookup[id].userType)
        };
    };
const added = (user)=>({ byId, ids, active, byCompanyId, byMemberType })=>{
        var _byCompanyId_user_company_companyId, _byMemberType_user_userType;
        const [, userIds = []] = ids;
        return {
            byId: {
                ...byId,
                [user.userId]: Loaded(user)
            },
            ids: Loaded(union(userIds, [
                user.userId
            ])),
            active: union(active, [
                user.userId
            ].filter(()=>user.userStatus !== UserStatus.Inactive)),
            byCompanyId: {
                ...byCompanyId,
                [user.company.companyId]: union((_byCompanyId_user_company_companyId = byCompanyId[user.company.companyId]) !== null && _byCompanyId_user_company_companyId !== void 0 ? _byCompanyId_user_company_companyId : [], [
                    user.userId
                ])
            },
            byMemberType: {
                ...byMemberType,
                [user.userType]: union((_byMemberType_user_userType = byMemberType[user.userType]) !== null && _byMemberType_user_userType !== void 0 ? _byMemberType_user_userType : [], [
                    user.userId
                ])
            }
        };
    };
const addedAll = (users)=>(store)=>users.reduce((state, user)=>added(user)(state), store);
const loaded = ({ ids: [status] })=>status === 'loaded' || status === 'refreshing';
const toList = ({ ids: [, userIds = []], byId })=>userIds.map((x)=>byId[x]).filter(Boolean).filter(([status])=>status === 'loaded' || status === 'refreshing').map(([, user])=>user);
// TODO: Strongly type
const ofCompanyId = ([, companyId])=>({ byCompanyId })=>{
        var _byCompanyId_companyId;
        return (_byCompanyId_companyId = byCompanyId[companyId]) !== null && _byCompanyId_companyId !== void 0 ? _byCompanyId_companyId : [];
    };
const activeUsers = ({ active: active_list, byId })=>active_list.map((x)=>byId[x]).filter(Boolean).filter(([status])=>status === 'loaded' || status === 'refreshing').map(([, user])=>user);
const ofMemberType = (type)=>({ byMemberType })=>{
        var _byMemberType_type;
        return (_byMemberType_type = byMemberType[type]) !== null && _byMemberType_type !== void 0 ? _byMemberType_type : [];
    };
export const UsersStore = {
    empty: ()=>EMPTY,
    putAll,
    loaded,
    toList,
    ofCompanyId,
    activeUsers,
    ofMemberType,
    added,
    addedAll
};
